import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';

export const RemodelOperationalProjectStyles = css`
  ${MainStyles}
  .grid-styles {
    width: 100%;
    height: 100%;
  }
  .container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
  .remodel-project-description {
    margin: 16px;
    font-size: 13px;
    font-family: 'Roboto-Regular', 'Roboto', sans-serif;
    color: #c9c9c9;
    text-align: left;
    line-height: normal;
  }
`;
